import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class HiddenInput extends Component {
    static propTypes = {
        name: PropTypes.string,
        onChange: PropTypes.func,
        'aria-required': PropTypes.bool,
    };

    static defaultProps = {
        name: null,
        onChange: () => {},
        'aria-required': undefined,
    };

    render() {
        return (
            <input
                name={this.props.name}
                style={{
                    display: 'none',
                }}
                onClick={this.props.onChange}
                type="text"
                aria-required={this.props['aria-required']}
            />
        );
    }
}
